import React, { useEffect, useMemo, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
  dateTimeToServerIso,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import { GalleryField } from "components/form";
import { CkEditorFull } from "components/form";
import extractValues from "utils/extractValues";
import initItem from "utils/initItem";
import MyFormComponent from "utils/DynamicEntityTypeFields";
import TextFieldSlug from "components/form/TextFieldSlug";
import MultiselectAdd from "components/form/MultiSelectAdd";
import CkEditorFullNew from "components/form/CkEditorFullNew";
import VideoSelector from "utils/VideoSelector";
import formatTime from "utils/formatTime";
import MultiselectAddNew from "components/form/MultiSelectAddNew";
import { useList } from "store/list";
import { getSliderName } from "store/core";
import { refsToIds } from "utils/contentTaxonomy";

export default function Edit(props) {
  const [showSelect, setShowSelect] = useState(false);
  const [video, setVideo] = useState(null);
  const { dispatch, clear } = useList();

  const core = useCore();
  const { show, item } = props;

  const config = {
    player: {
      valueField: "id",
      labelFields: ["translations.fa.name", "translations.fa.lastName"],
    },
    staff: {
      valueField: "id",
      labelFields: ["translations.fa.name", "translations.fa.lastName"],
    },
    coach: {
      valueField: "id",
      labelFields: ["translations.fa.name", "translations.fa.lastName"],
    },
    referee: {
      valueField: "id",
      labelFields: ["translations.fa.name", "translations.fa.lastName"],
    },
    team: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    league: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    match: {
      valueField: "id",
      labelFields: [
        "homeTeam.translations.fa.name",
        "awayTeam.translations.fa.name",
      ],
    },
  };
  const baseInitialValues = useMemo(() => {
    const initialValues = {
      ...(item || {}),
      categories: refsToIds(item?.categories),
      tags: refsToIds(item?.tags),
    };

    return initItem(initialValues, config);
  }, [item]);

  useEffect(() => {
    setVideo(null);
    setShowSelect(false);
  }, [item]);

  useEffect(() => {
    dispatch(getSliderName("selectFields=id type"));

    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <div className="z-[99999999999999] ">
        <VideoSelector
          title="انتخاب ویدیو"
          show={showSelect}
          setVideo={setVideo}
          close={() => {
            setShowSelect(false);
          }}
        />
      </div>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          key={item?.id || "edit-video"}
          initialValues={baseInitialValues}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.publishedAt)
              values.publishedAt = dateTimeToServerIso(values.publishedAt);

            const clean = cleanObject(values, [
              "id",
              "updatedAt",
              "uuid",
              "createdAt",
              "viewsCount",
              "author",
            ]);

            const result = extractValues(clean, [
              "player",
              "staff",
              "coach",
              "referee",
              "team",
              "league",
              "match",
            ]);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useEffect(() => {
              if (video) {
                setFieldValue("streamSlug", video.fullSlug);
                setFieldValue("streamDuration", formatTime(video.duration));
              }
            }, [video, setFieldValue]);

            return (
              <Form>
                <div className="flex flex-col gap-5">
                  <div className="p-2 border border-gray-200 rounded-lg">
                    <div className="space-y-4">
                      <div className="grid md:grid-cols-2 gap-4">
                      <Field
                        placeholder="عنوان"
                        label="عنوان :"
                        name="translations.fa.title"
                        component={TextFieldSlug}
                        slugFieldName="translations.fa.slug"
                      />
                      {/* <Field
                          placeholder="عنوان(en)"
                          label="عنوان (en):"
                          name="translations.en.title"
                          component={TextFieldSlug}
                          slugFieldName="translations.en.slug"
                        /> */}

                      <div className="intro-y">
                        <Field
                          label="نامک:"
                          name="translations.fa.slug"
                          component={TextField}
                        />
                      </div>
                      {/* <div className="intro-y">
                          <Field
                            label="نامک انگلیسی:"
                            name="translations.en.slug"
                            component={TextField}
                          />
                        </div> */}
                    </div>

                    <div className="w-full">
                      <Field
                        label="خلاصه"
                        name="translations.fa.summary"
                        component={TextArea}
                      />
                    </div>
                    {/* <Field
                          label="خلاصه انگلیسی"
                          name="translations.en.summary"
                          component={TextArea}
                        /> */}

                    <div>
                      <Field
                        label="توضیحات:"
                        name="translations.fa.content"
                        component={CkEditorFullNew}
                      />
                    </div>
                  </div>

                  <div className="space-y-4">
                    <Field
                      label="دسته بندی ها:"
                      name="categories"
                      valueOnly
                      type="Video"
                      collection="category"
                      component={MultiselectAdd}
                      options={core.categories || []}
                      initialSelectedItems={item?.categories || []}
                    />
                    <Field
                      label=" تگ ها:"
                      name="tags"
                      valueOnly
                      type="Video"
                      collection="tag"
                      component={MultiselectAdd}
                      options={core.tags || []}
                      initialSelectedItems={item?.tags || []}
                    />
                    <Field
                      label=" کلمات کلیدی :"
                      name="keywords"
                      valueOnly
                      component={MultiselectAddNew}
                    />
                  </div>

                  <div className="space-y-4">
                    <Field
                      label="وضعیت:"
                      name="status"
                      component={Select}
                      options={[
                        { value: "draft", label: "پیش نویس" },
                        { value: "published", label: "منتشر شده" },
                        { value: "archived", label: "بایگانی شده" },
                      ]}
                      className="w-full px-3 py-2 border rounded mt-2"
                    />

                    {values?.status === "published" && (
                      <div className="intro-y col-span-2">
                        <Field
                          label="مشخص کردن وضعیت اسلایدر :"
                          name="slider"
                          valueOnly
                          type="Video"
                          collection="slider"
                          component={Select}
                          options={core?.slider || []}
                        />
                      </div>
                    )}
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <Field
                          label="نمایش ویژه:"
                          name="isFeatured"
                          component={Select}
                          options={[
                            { value: true, label: "بله" },
                            { value: false, label: "خیر" },
                          ]}
                          className="w-full px-3 py-2 border rounded"
                        />
                      </div>
                      <div>
                        <Field
                          label="نظرات فعال باشد:"
                          name="commentsEnabled"
                          component={Select}
                          options={[
                            { value: true, label: "بله" },
                            { value: false, label: "خیر" },
                          ]}
                          className="w-full px-3 py-2 border rounded"
                        />
                      </div>
                      <div>
                        <Field
                          label=" تاریخ انتشار:"
                          name="publishedAt"
                          hasTime
                          component={PersianDataPicker}
                        />
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        onClick={() => {
                          setShowSelect(true);
                        }}
                        className="btn btn-primary shadow-md "
                        type="button"
                      >
                        انتخاب ویدیو
                      </button>
                    </div>
                    {video && (
                      <div className="mt-3 p-3 bg-green-100 border border-green-400 rounded-lg">
                        <p className="text-green-700 font-semibold text-[13px]">
                          ویدیو انتخاب شده: {video?.title}
                        </p>
                      </div>
                    )}
                    <div>
                      <Field
                        label="اسلاگ استریم:"
                        name="streamSlug"
                        component={TextField}
                      />
                    </div>
                    <div>
                      <Field
                        label="تایم استریم:"
                        name="streamDuration"
                        component={TextField}
                      />
                    </div>
                    <div>
                      <Field
                        label="آیدی استریم:"
                        name="streamId"
                        component={TextField}
                      />
                    </div>
                    <div>
                      <Field
                        label="رمزگذاری پیشرفته استریم:"
                        name="streamDrmX"
                        component={Select}
                        options={[
                          { value: true, label: "بله" },
                          { value: false, label: "خیر" },
                        ]}
                        className="w-full px-3 py-2 border rounded"
                      />
                    </div>
                    {/* <div>
                        <MyFormComponent />
                      </div> */}
                    <div className="mt-3">
                      <Field
                        label="مدیا"
                        name="media"
                        dataType="id"
                        component={GalleryField}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex  gap-x-4">
                  <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={props.close}
                    className="btn btn-outline-secondary w-20 mr-1"
                  >
                    انصراف
                  </button>
                  <button
                    className="btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
}
